import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalpopupComponent } from './globalpopup.component';
import { GlobalPopupAppendDirective } from '../../shared/directives/globalPopupAppend.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [GlobalpopupComponent, GlobalPopupAppendDirective],
  exports: [GlobalpopupComponent]
})
export class GlobalpopupModule { } 


// WEBPACK FOOTER //
// ./src/app/shared/globalpopup/globalpopup.module.ts